import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5fhorwgw5m: FaireBrandEntity = {
  token: "b_5fhorwgw5m",
  type: "brand",
  name: "Peter and June",
  avatarUrl:
    "https://cdn.faire.com/fastly/3d1f3d4dfbe8b34a30a1d351e897ae39b099f8db867254ff0fdca18b6727171b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5d8a5a6af86caf41573dfff81dce3f261d08842852bce328a98c83425cf8d52d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3d1f3d4dfbe8b34a30a1d351e897ae39b099f8db867254ff0fdca18b6727171b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5d8a5a6af86caf41573dfff81dce3f261d08842852bce328a98c83425cf8d52d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 130,
  rating: 4.9,
  reviewCount: 89,
  isTopShop: true,
  isInsider: true,
  description:
    "Born in Denver in 2018 and based in Los Angeles, we are woman owned company operated by a small team of longtime employees and two handsome black cats. \n\nOur collections are handmade in and out of the USA with components ethically sourced and artisan supported. We love offering a wide array of products from classic shapes and metals to the playfully whimsical, and everything in between. \n\nThe brand brings us so much joy, hopefully we can pass that on ❤️\n\nThanks for visiting.\n-Peter and June team\n\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.510Z",
    importedBy: "entity-db-cli",
  },
};
